import { render, staticRenderFns } from "./hero-cloudflare-video.vue?vue&type=template&id=5f50deb6&"
import script from "./hero-cloudflare-video.vue?vue&type=script&lang=js&"
export * from "./hero-cloudflare-video.vue?vue&type=script&lang=js&"
import style0 from "./hero-cloudflare-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports